import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bd519c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "independent-scroll-main" }
const _hoisted_2 = { class: "independent-scroll-child" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "desktop-only independent-scroll-child"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_InitialJobConfiguration = _resolveComponent("InitialJobConfiguration")!
  const _component_JobConfiguration = _resolveComponent("JobConfiguration")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_menu_button, { slot: "start" }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.translate("Initial load")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createElementVNode("main", _hoisted_1, [
            _createElementVNode("section", _hoisted_2, [
              _createElementVNode("div", null, [
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("Products")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      fill: "outline",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewInitialJobConfiguration('products', _ctx.jobEnums['IMP_PRDTS_BLK'])))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Import products in bulk")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { lines: "none" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, _toDisplayString(_ctx.translate("Import all products from Shopify. Make sure you run this before importing orders in bulk during intial setup.")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("Orders")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_button, {
                      expand: "block",
                      fill: "outline",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewInitialJobConfiguration('orders', _ctx.jobEnums['IMP_ORDERS_BLK'])))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.translate("Import orders in bulk")), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, { lines: "none" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createElementVNode("p", null, _toDisplayString(_ctx.translate("Before importing historical orders in bulk, make sure all products are set up or else order import will not run correctly.")), 1),
                            _hoisted_3,
                            _createElementVNode("p", null, _toDisplayString(_ctx.translate("By default only open and unshipped orders will be imported.")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_card_header, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_card_title, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("Process Uploads")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, {
                      button: "",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.viewJobConfiguration({ id: 'JOB_IMP_QUEUE', status: _ctx.getJobStatus(_ctx.jobEnums['JOB_IMP_QUEUE']) }))),
                      detail: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.translate("Import queue")) + " ", 1),
                            _createElementVNode("p", null, _toDisplayString(_ctx.getTemporalExpression('JOB_IMP_QUEUE')), 1)
                          ]),
                          _: 1
                        }),
                        (!_ctx.isLoading)
                          ? (_openBlock(), _createBlock(_component_ion_label, {
                              key: 0,
                              slot: "end"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.translate(_ctx.getJob(_ctx.jobEnums['JOB_IMP_QUEUE'])?.status === "SERVICE_DRAFT" ? "Disabled" : "Enabled")), 1)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_ion_skeleton_text, {
                              key: 1,
                              style: {"width":"30%"},
                              animated: ""
                            }))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_checkbox, {
                          disabled: !_ctx.hasPermission(_ctx.Actions.APP_JOB_UPDATE),
                          checked: _ctx.processPendingUploadsOnShopify,
                          onIonChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateJob($event['detail'].checked, _ctx.jobEnums['UL_PRCS'])))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.translate("Upload Pending Process")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["disabled", "checked"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            (_ctx.isDesktop)
              ? _withDirectives((_openBlock(), _createElementBlock("aside", _hoisted_4, [
                  (_ctx.currentSelectedJobModal)
                    ? (_openBlock(), _createBlock(_component_InitialJobConfiguration, {
                        type: _ctx.currentSelectedJobModal,
                        shopifyOrderId: _ctx.lastShopifyOrderId,
                        key: _ctx.job
                      }, null, 8, ["type", "shopifyOrderId"]))
                    : (_openBlock(), _createBlock(_component_JobConfiguration, {
                        status: _ctx.currentJobStatus,
                        type: _ctx.freqType,
                        key: _ctx.currentJob
                      }, null, 8, ["status", "type"]))
                ], 512)), [
                  [_vShow, _ctx.currentSelectedJobModal || Object.keys(_ctx.currentJob)?.length]
                ])
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}